import { api } from './client'

/**
 * O prazo de fabricação de uma família (demanda 160 · decisões D6 e D7 de
 * 02/09).
 */
export type PrazoDaFamilia = {
  /** `geral` para o de toda a casa; o nome da família para o resto. */
  familia: string

  /** O que está gravado para esta linha, ou nulo. */
  dias: number | null

  /** O que vale hoje — já com o recuo família → geral → zero aplicado. */
  efetivo: number

  /** Nada gravado aqui: quem manda é o geral. */
  usaOGeral: boolean

  atualizadoEm: string | null
  atualizadoPor: string | null
}

export type PrazosDeFabricacao = {
  linhas: PrazoDaFamilia[]

  /**
   * 🔴 Há prazo gravado que o **retrato publicado** ainda não conhece.
   *
   * O motor lê a configuração publicada, não a gravada — editar sem publicar
   * deixa a mudança sem efeito, e foi o que a 123 e a 149 encontraram em
   * produção.
   */
  precisaPublicar: boolean
}

export const prazos = {
  listar: () => api.get<PrazosDeFabricacao>('/precificacao/prazos'),

  /** `null` apaga: a família volta a usar o geral. */
  gravar: (familia: string, dias: number | null) =>
    api.put<{ familia: string; dias: number | null }>(
      `/precificacao/prazos/${encodeURIComponent(familia)}`,
      { dias },
    ),
}
